Vue.component('MobileOfferTile', {
    filters: {
        toInt: function (value) {
            if (!value) return 0
            const parsed = parseInt(value, 10);
            if (isNaN(parsed)) {
                return 0;
            }
            return parsed
        }
    },
    props: {
        offer: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            loading: false
        }
    },
    methods: {
        onTileClick(event) {
            this.loading = true;
            this.$emit('offer-selected', this.offer);
        }
    },
    template: `
        <ob1-tuile-des-offres :is-selected="false"
                              :is-reversed="true"
                              :is-disabled="false"
                              additional-classes="h-100">
        <div class="d-flex flex-column h-100 p-1 pt-2">
            <div class="title-wrapper mt-1 mb-0 d-flex flex-column justify-content-between">
                <a @click.prevent="onTileClick" href="#">
                    <h3 class="mb-0 text-white">{{ offer.name }}</h3>
                </a>
            </div>
            <div class="spinner-wrapper d-flex justify-content-center">
                <div v-if="loading">
                    <ob1-progress-indicators :size="50" type="undetermined" class="my-auto"/>
                </div>
            </div>
            <div class="price-wrapper mt-auto">
                <ob1-prix :price="offer.price.price"
                          :duration="offer.price.duration | toInt"
                          :initial-price="offer.price.initialPrice"
                          :show-by-month="offer.price.showByMonth"
                          :show-from="offer.price.showFrom"
                          :show-promo-duration="offer.price.showPromoDuration"
                          :price-details="offer.price.priceDetails"
                          :is-inverse="true"
                ></ob1-prix>
            </div>
        </div>
        </ob1-tuile-des-offres>
    `
});
